import { createSlice } from '@reduxjs/toolkit';
import { logout } from './auth-slice';

const initialState = {
  codigo: null,
  discountType: null,
  discountValue: null,
  tope: 0,
  lineas: [],
  message: null,
};

const cuponSlice = createSlice({
  name: 'cupon',
  initialState,
  reducers: {
    applyCupon(state, action) {
      state.codigo = action.payload.codigo;
      state.discountType = action.payload.discount_type;
      state.discountValue = action.payload.discount_value;
      state.tope = action.payload.tope ?? 0;
      state.lineas = action.payload.lineas ?? [];
      state.message = action.payload.message;
    },
    clearCupon(state) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { applyCupon, clearCupon } = cuponSlice.actions;
export default cuponSlice.reducer;
